import { useEffect, useState } from "react";

import { fetchData } from "./fetchData";
import type { SheetData } from "./types";

export interface DataState extends Partial<SheetData> {
  error?: unknown;
  loading: boolean;
}

export function useData(): DataState {
  const [data, setData] = useState<SheetData>();
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    let active = true;

    fetchData()
      .then((loadedData) => {
        if (active) setData(loadedData);
      })
      .catch((loadError: unknown) => {
        if (active) setError(loadError);
      });

    return () => {
      active = false;
    };
  }, []);

  const { matchups, countries, rows, pricepool } = data ?? {};

  return {
    matchups,
    countries,
    rows,
    pricepool,
    error,
    loading: !data && !error,
  };
}
